import axiosInstance from "../../../util/axiosInstance";



export const PlaceOrder = async (paymentAmount) => {
  try {
    const response = await axiosInstance.post('/create-order', {
      amount: paymentAmount,
    });

    const orderData = response.data;
    console.log('Order created on backend:', orderData);


  } catch (error) {
    console.error('Error creating order:', error.response?.data || error.message);
  }
};

export const payment_checkout = async (eventId, request) => {
  try {

    const response = await axiosInstance.post(
      `/cart/event/${eventId}/checkout-multi`,
      request
    );
    console.log("payment_checkout", response)
    return response.data; // backend response
  } catch (error) {
    console.error("Payment Checkout Error:", error);
    throw error.response?.data || error.message;
  }
};

export const payment_verification = async (eventId, verificationData) => {
  try {
    const response = await axiosInstance.post(
      `/cart/event/${eventId}/payments/verify-multi`,
      verificationData
    );

    console.log("Payment verification response:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Payment verification failed:", error.response?.data || error.message);
    throw error;
  }
};